import { Box } from '@mui/material';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { AwardType } from '@occc-app/offerHelpers/types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { routeCreator as awardRouteCreator } from '@occc-app/routes/AwardCatalog/utils';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LinkChip } from '@occc/ui-design-system';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { displayAmount } from '@occc-app/lib/currency';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { pluralize } from '@occc-app/lib/strings';
import { Constraint_Purchase_Threshold_Counting_Attribute } from '@occc/graphql';

import { ConfigurationDetailsAward } from './configuration-details.types';

export const mapAwardToText = (award: ConfigurationDetailsAward) => {
  if (award.type === AwardType.AwardPoints) {
    return `${award.points} Points`;
  }
  if (award.type === AwardType.AwardVouchers) {
    return (
      <>
        <LinkChip
          label={award.voucheredOffer.name}
          href={awardRouteCreator.details(award.voucheredOffer.id)}
        />
        <Box mt={1} component='span' sx={{ display: 'block' }}>
          {`${award.voucherCount} ${pluralize(award.voucherCount, 'award')}`}
        </Box>
      </>
    );
  }
  return 'Nothing';
};

export const formatThreshold = (params: {
  threshold: number;
  countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute;
}): string => {
  if (params.countProductsBy === Constraint_Purchase_Threshold_Counting_Attribute.MoneyAmount) {
    return displayAmount(params.threshold, true);
  }
  return params.threshold.toString();
};
